import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function QuickNoteDialog({ open, dossier, onClose, onAdded }) {
  const [content, setContent] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => { if (open) setContent(""); }, [open]);
  if (!open || !dossier) return null;

  const submit = async () => {
    if (!content.trim()) return;
    setSubmitting(true);
    try {
      await api.post(`/dossiers/${dossier.id}/notes`, { content: content.trim() });
      toast.success("Note ajoutée");
      onAdded?.();
      onClose();
    } catch { toast.error("Erreur"); }
    finally { setSubmitting(false); }
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-end md:items-center justify-center bg-slate-900/40 backdrop-blur-sm"
      onClick={onClose}
      data-testid="quick-note-dialog"
    >
      <div className="w-full md:max-w-md bg-white rounded-t-3xl md:rounded-3xl p-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-display text-xl font-extrabold text-slate-900">Ajouter une note</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center"><X size={18} /></button>
        </div>
        <p className="text-sm text-slate-500">Sur {dossier.nom}</p>
        <textarea
          value={content} onChange={(e) => setContent(e.target.value)}
          placeholder="Échange téléphonique, avancement, point bloquant…"
          className="cf-input mt-4 h-24 resize-none"
          autoFocus
          data-testid="quick-note-input"
        />
        <div className="flex gap-2 mt-4">
          <button onClick={onClose} className="flex-1 px-4 py-3 rounded-xl bg-slate-100 text-slate-700 text-sm font-bold" data-testid="quick-note-cancel">Annuler</button>
          <button onClick={submit} disabled={!content.trim() || submitting} className="flex-1 px-4 py-3 rounded-xl bg-[color:var(--cf-primary)] text-white text-sm font-bold disabled:opacity-40" data-testid="quick-note-confirm">
            {submitting ? "…" : "Ajouter"}
          </button>
        </div>
      </div>
    </div>
  );
}
